var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleFavicon2025(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "269px",
    height: "274px",
    viewBox: "0 0 269 274",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M355.75154,190.391267 L227.106543,190.391267 L227.106543,243.040831 L301.02651,243.040831 C299.838207,250.492019 297.170011,257.822021 293.262648,264.505794 C288.785895,272.163491 283.251309,277.993442 277.578591,282.433198 C260.586108,295.732466 240.775227,298.451868 227.016785,298.451868 C192.261076,298.451868 162.564632,275.508728 151.068514,244.333092 C150.604593,243.201822 150.296525,242.033113 149.921403,240.878 C147.380994,232.943446 145.992965,224.540009 145.992965,215.805822 C145.992965,206.715859 147.49604,198.014579 150.236655,189.796567 C161.0469,157.384929 191.412836,133.176524 227.041787,133.176524 C234.208097,133.176524 241.109255,134.047785 247.653682,135.785578 C262.610197,139.757042 273.189775,147.578883 279.672417,153.765891 L318.788203,114.640331 C294.994379,92.3578037 263.976481,78.8557707 226.976744,78.8557707 C197.397837,78.8557707 170.089301,88.2679905 147.710902,104.176036 C129.562686,117.077063 114.67859,134.349864 104.633628,154.410346 C95.290383,173.010482 90.1743611,193.622904 90.1743611,215.78523 C90.1743611,237.948541 95.2981996,258.775255 104.641483,277.203465 L104.641483,277.327607 C114.510283,296.89152 128.941857,313.736425 146.481888,326.578337 C161.805,337.797041 189.280789,352.738433 226.976744,352.738433 C248.654615,352.738433 267.867273,348.746476 284.811093,341.265435 C297.034178,335.8687 307.863965,328.829842 317.668967,319.783329 C330.624575,307.829919 340.770981,293.04469 347.696469,276.033967 C354.621958,259.023145 358.32653,239.786928 358.32653,218.931543 C358.32653,209.218899 357.371386,199.355117 355.75154,190.390282 L355.75154,190.391267 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "98.7969747%",
    cy: "97.8717753%",
    fx: "98.7969747%",
    fy: "97.8717753%",
    r: "141.373746%",
    gradientTransform: "translate(0.988, 0.9787), scale(0.9273, 1), rotate(-92.3395), translate(-0.988, -0.9787)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ABD4D",
    offset: "14.16122%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EC30D",
    offset: "24.75151%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC502",
    offset: "31.15468%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C600",
    offset: "36.60131%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C903",
    offset: "44.56735%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBCB03",
    offset: "54.0305%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CD07",
    offset: "61.56363%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCD04",
    offset: "69.93454%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCE05",
    offset: "77.12418%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE0A",
    offset: "86.05661%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "96.1102556%",
    cy: "96.2249642%",
    fx: "96.1102556%",
    fy: "96.2249642%",
    r: "123.047933%",
    gradientTransform: "translate(0.9611, 0.9622), scale(0.7971, 1), rotate(-0.0001), translate(-0.9611, -0.9622)",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB4E5A",
    offset: "40.84578%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4540",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "134.234503%",
    cy: "-20.6665276%",
    fx: "134.234503%",
    fy: "-20.6665276%",
    r: "177.059957%",
    gradientTransform: "translate(1.3423, -0.2067), scale(0.8084, 1), rotate(151.0197), translate(-1.3423, 0.2067)",
    id: "radialGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4541",
    offset: "23.12727%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4540",
    offset: "31.15468%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4640",
    offset: "45.75163%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF473F",
    offset: "54.0305%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5138",
    offset: "69.93464%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5B33",
    offset: "77.12418%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C29",
    offset: "86.05665%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C18",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "9.93421464%",
    cy: "86.9274306%",
    fx: "9.93421464%",
    fy: "86.9274306%",
    r: "291.592126%",
    gradientTransform: "translate(0.0993, 0.8693), scale(0.9322, 1), rotate(-127.4542), translate(-0.0993, -0.8693)",
    id: "radialGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CBA65",
    offset: "13.15461%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BB86D",
    offset: "20.97843%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09B479",
    offset: "29.72969%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08AD93",
    offset: "39.62575%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AA6A9",
    offset: "47.71242%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D9CC6",
    offset: "56.84245%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1893DD",
    offset: "66.7385%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#258BF1",
    offset: "76.87273%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3086FF",
    offset: "85.85063%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "147.159148%",
    cy: "-18.9928923%",
    fx: "147.159148%",
    fy: "-18.9928923%",
    r: "170.840195%",
    gradientTransform: "translate(1.4716, -0.1899), scale(1, 0.8666), rotate(96.6178), translate(-1.4716, 0.1899)",
    id: "radialGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E3A",
    offset: "36.60131%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A1B",
    offset: "45.75163%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA312",
    offset: "54.0305%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB60C",
    offset: "61.56363%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD0A",
    offset: "77.12418%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECF0A",
    offset: "86.05665%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECF08",
    offset: "91.50327%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCD01",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "93.5525917%",
    cy: "19.0288473%",
    fx: "93.5525917%",
    fy: "19.0288473%",
    r: "106.164776%",
    gradientTransform: "translate(0.9355, 0.1903), scale(0.8555, 1), rotate(132.1192), translate(-0.9355, -0.1903)",
    id: "radialGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C3C",
    offset: "31.59041%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF692C",
    offset: "60.38179%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7825",
    offset: "72.68366%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D1B",
    offset: "88.4534%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F13",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "137.736148%",
    cy: "124.421988%",
    fx: "137.736148%",
    fy: "124.421988%",
    r: "219.563799%",
    gradientTransform: "translate(1.3774, 1.2442), scale(0.6993, 1), rotate(-151.0197), translate(-1.3774, -1.2442)",
    id: "radialGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBC5F",
    offset: "23.12727%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBC5F",
    offset: "31.15468%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBC5E",
    offset: "36.60131%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBC5D",
    offset: "45.75163%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12BC58",
    offset: "54.0305%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BF3C",
    offset: "69.93464%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38C02B",
    offset: "77.12418%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52C218",
    offset: "86.05665%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C30F",
    offset: "91.50327%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86C504",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBC5C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CBA65",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-90.1744, -78.8558)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2012716,216.715212 C88.3434656,238.528758 94.4291057,261.034938 103.640742,279.203434 L103.640742,279.328463 C110.296576,292.522899 119.393195,302.945419 129.754079,313.272271 L192.331292,289.951285 C180.492046,283.808811 178.685501,280.04494 170.198696,273.177023 C161.525957,264.244898 155.062091,253.99066 151.036615,241.967101 L150.874439,241.967101 L151.036615,241.842072 C148.388344,233.902197 148.127119,225.474129 148.029411,216.715212 L88.2012716,216.715212 Z",
    fill: "url(#radialGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.1075,77.8596877 C220.92239,100.053236 223.287308,121.626084 227.1075,134.178134 C234.249863,134.183553 241.130329,135.053139 247.654353,136.785513 C262.610868,140.756978 273.189296,148.579016 279.671938,154.766023 L319.789136,114.640922 C296.023666,92.3849573 267.423085,77.8947529 227.1075,77.8596877 L227.1075,77.8596877 Z",
    fill: "url(#radialGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.973296,77.6841842 C196.635044,77.6841842 168.625596,87.3380379 145.672731,103.65454 C137.150291,109.712873 129.329432,116.711238 122.365435,124.49357 C120.541073,141.974851 136.022433,163.461095 166.680344,163.283257 C181.55534,145.610442 203.555168,134.176164 228.041091,134.176164 C228.063411,134.176164 228.085156,134.178036 228.107475,134.178134 L227.1075,77.6881844 C227.062287,77.6881548 227.01851,77.6841842 226.973296,77.6841842 L226.973296,77.6841842 Z",
    fill: "url(#radialGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.106511,223.040845 L300.027493,242.04129 C298.83919,249.492478 296.169174,256.822381 292.261811,263.506154 C287.785058,271.163852 282.250951,276.994098 276.578233,281.433854 C259.620906,294.705633 239.862424,297.438238 226.107526,297.44947 C211.890526,322.181144 209.398013,334.568853 227.1075,354.52943 C249.021116,354.512976 268.44854,350.472741 285.584615,342.906869 C297.971696,337.437719 308.946321,330.304177 318.882846,321.136281 C332.012221,309.022571 342.296471,294.038418 349.314879,276.79951 C356.333286,259.560503 360.086328,240.067036 360.086328,218.931937 L327.106511,223.040845 Z",
    fill: "url(#radialGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.107455,188.391003 L225.107455,245.041293 L355.390786,245.041293 C356.536653,237.282903 360.326288,227.243253 360.326288,218.931937 C360.326288,209.219293 359.37191,197.355838 357.752064,188.391003 L225.107455,188.391003 Z",
    fill: "#3086FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.987031,122.493601 C114.947191,131.47824 108.078699,141.534639 102.632817,152.410475 C93.289715,171.010612 88.173923,193.623199 88.173923,215.785525 C88.173923,216.097851 88.1992313,216.403379 88.2012716,216.715212 C92.3390445,224.818343 145.357096,223.266665 148.029411,216.715212 C148.026058,216.409487 147.992339,216.111448 147.992339,215.805033 C147.992339,206.715071 149.495894,200.01514 152.236509,191.797128 C155.617398,181.660332 160.911163,172.32573 167.680414,164.283192 C169.21491,162.282238 173.308015,157.980614 174.50216,155.400429 C174.957077,154.417637 173.676336,153.865993 173.604683,153.520069 C173.524601,153.13316 171.80743,153.444303 171.422728,153.156116 C170.201282,152.241011 167.782529,151.763163 166.313747,151.338419 C163.174445,150.430507 157.971683,148.42837 155.08192,146.352931 C145.947463,139.792512 131.692339,131.956187 122.987031,122.493601 L122.987031,122.493601 Z",
    fill: "url(#radialGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.278102,153.55879 C176.459961,166.663962 182.551483,146.943886 196.634469,140.773037 L172.136668,88.8854498 C163.125016,92.7539747 154.610814,97.5602752 146.710927,103.176002 C134.91316,111.56269 124.4948,121.796829 115.888541,133.44343 L155.278102,153.55879 Z",
    fill: "url(#radialGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.899209,285.942677 C135.465306,296.427071 131.013842,296.803142 128.396512,314.801091 C133.39811,319.786186 138.771957,324.397475 144.482513,328.578404 C159.805625,339.797208 189.280693,354.7386 226.976648,354.7386 C227.020904,354.7386 227.063244,354.734659 227.1075,354.734659 L227.1075,296.449534 C227.078954,296.449633 227.046193,296.451505 227.017647,296.451505 C212.901805,296.451505 201.62189,292.664677 190.056419,286.07943 C187.204876,284.455828 182.031427,288.81568 179.401548,286.866649 C175.774376,284.178479 167.045216,289.182786 163.899209,285.942677 L163.899209,285.942677 Z",
    fill: "url(#radialGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.455176,294.61361 L210.455176,353.724871 C215.729495,354.355631 221.218483,354.7386 226.976648,354.7386 C232.748991,354.7386 238.333388,354.435831 243.759825,353.879162 L243.759825,295.012047 C237.678745,296.073857 231.951329,296.451505 227.017647,296.451505 C221.335446,296.451505 215.809481,295.775817 210.455176,294.61361 Z",
    fill: "url(#linearGradient-10)",
    opacity: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleFavicon2025);
export default __webpack_public_path__ + "static/media/Google_Favicon_2025.f899ce1ac233fcbf8e981cdf68006aa4.svg";
export { ForwardRef as ReactComponent };